import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.808 16.538h-3.77c-1.255 0-2.325-.442-3.21-1.327-.885-.885-1.328-1.955-1.328-3.21 0-1.256.443-2.326 1.328-3.212.885-.885 1.955-1.327 3.21-1.327h3.77v1.5h-3.77c-.84 0-1.556.296-2.149.889A2.928 2.928 0 0 0 4 12c0 .84.296 1.556.89 2.149.592.593 1.309.89 2.148.89h3.77v1.5ZM8.25 12.75v-1.5h7.5v1.5zm4.942 3.788v-1.5h3.77c.84 0 1.556-.296 2.149-.889.592-.593.889-1.31.889-2.149 0-.84-.297-1.556-.89-2.15a2.928 2.928 0 0 0-2.148-.889h-3.77v-1.5h3.77c1.255 0 2.326.443 3.21 1.328.886.885 1.328 1.955 1.328 3.21 0 1.256-.442 2.326-1.328 3.211-.884.886-1.955 1.328-3.21 1.328z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }